import {
    Navigate,
    Route,
    Routes,
} from 'react-router-dom';

import {IndexPage} from './pages/IndexPage';
import {DetailPage} from "./pages/DetailPage.tsx";
import {useVerifiedPermissions} from "../../../hooks/useVerifiedPermissions.ts";

export const CodeRepositoriesLayout = () => {

    const {allowedActions} = useVerifiedPermissions()


    return (
        <Routes>
            <Route
                path='/'
                element={
                    allowedActions.includes('ListPipelines') ? (
                        <IndexPage/>
                    ) : (
                        <Navigate to='/'/>
                    )
                }
            />
            <Route
                path=':name'
                element={
                    allowedActions.includes('ListPipelines') ? (
                        <DetailPage/>
                    ) : (
                        <Navigate to='/code-repositories'/>
                    )
                }

            >
            </Route>


        </Routes>
    );
};
